import { observer } from 'mobx-react-lite'
import { ViewAcceptedSection7216Dialog } from './index'
import { type ViewAcceptedSection7216DialogViewModel } from './ViewAcceptedSection7216DialogViewModel'

interface Props {
  vm: ViewAcceptedSection7216DialogViewModel
}

export const ViewAcceptedSection7216DialogContainer = observer(
  function ViewAcceptedSection7216DialogContainer({ vm }: Props) {
    return (
      <ViewAcceptedSection7216Dialog
        isOpen={vm.modal.showing}
        onClose={vm.modal.close}
        markup={vm.section7216.markup}
        userSignature={vm.userSignature}
        spouseSignature={vm.spouseSignature}
        dateAccepted={vm.dateAccepted}
      />
    )
  },
)
